<template>
    <el-date-picker
            :unlink-panels="true"
            :clearable="clearable"
            v-model="defaultValue"
            type="datetimerange"
            :picker-options="options"
            @change="changeDate"
            :value-format="valueFormat"
            format="dd/MM/yyyy hh:mm"
            range-separator="-"
            start-placeholder="От"
            end-placeholder="До"
            :default-time="['00:00:00', '23:59:00']"
            align="center">
    </el-date-picker>
</template>

<script>
    import Vue from 'vue'
    export default {
        props: {
            route: {
                type: [Boolean],
                default () {
                    return false
                }
            },
            clearable: {
                type: [Boolean],
                default () {
                    return true
                }
            },
            dateFrom: {
                type: [Object, Date, String],
                default () {
                    if (this.route && this.$route.query.from) {
                        return new Date(this.$route.query.from)
                    } else {
                        let oneWeekAgo = new Date()
                        oneWeekAgo.setDate(oneWeekAgo.getDate() - 30)
                        return new Date(oneWeekAgo)
                    }
                }
            },
            valueFormat: {
                type: [String],
                default () {
                    return 'dd/MM/yyyy HH:mm'
                }
            },
            dateTo: {
                type: [Object, Date, String],
                default () {
                    if (this.route && this.$route.query.to) {
                        return new Date(this.$routes.query.to)
                    } else {
                        return new Date()
                    }
                }
            }
        },
        methods: {
            changeDate (data) {
                if (data === null) {
                    data = [null, null]
                }
                console.log(data)
                if (this.route) {
                    this.$router.push({
                        name: this.$route.name,
                        query: {from: new Date(data[0]).toISOString(), to: new Date(data[1]).toISOString()}
                    })
                }
                this.$emit('changeDate', data)
            }
        },
        data () {
            return {
                name: 'dateTimePicker',
                dateTimeFormat: 'DD/MM/YYYY HH:mm',
                defaultValue: (this.dateFrom && this.dateTo) ? [this.dateFrom, this.dateTo] : '',
                options: {
                    shortcuts: [{
                        text: 'Сегодня',
                        onClick (picker) {
                            let startDate = Vue.moment().hour(0).minutes(0).format('DD/MM/YYYY HH:mm')
                            let endDate = Vue.moment().hour(24).minutes(0).format('DD/MM/YYYY HH:mm')
                            picker.$emit('pick', [startDate, endDate])
                        }
                    }, {

                        text: '24 часа',
                        onClick (picker) {
                            let startDate = Vue.moment().add(-24, 'hours').format('DD/MM/YYYY HH:mm')
                            let endDate = Vue.moment().hour('23').minutes('59').format('DD/MM/YYYY HH:mm')
                            picker.$emit('pick', [startDate, endDate])
                        }
                    }, {
                        text: 'Вчера',
                        onClick (picker) {
                            let startDate = Vue.moment().add(-1, 'days').hour(0).minutes(0).format('DD/MM/YYYY HH:mm')
                            let endDate = Vue.moment().hour(0).minutes(0).format('DD/MM/YYYY HH:mm')
                            picker.$emit('pick', [startDate, endDate])
                        }
                    }, {
                        text: 'Неделя',
                        onClick (picker) {
                            let startDate = Vue.moment().add(-7, 'days').format('DD/MM/YYYY HH:mm')
                            let endDate = Vue.moment().hour('23').minutes('59').format('DD/MM/YYYY HH:mm')
                            picker.$emit('pick', [startDate, endDate])
                        }
                    }, {
                        text: 'Месяц',
                        onClick (picker) {
                            let startDate = Vue.moment().add(-1, 'month').format('DD/MM/YYYY HH:mm')
                            let endDate = Vue.moment().hour('23').minutes('59').format('DD/MM/YYYY HH:mm')
                            picker.$emit('pick', [startDate, endDate])
                        }
                    }]
                }
            }
        },
        mounted () {
            this.$emit('init', [Vue.moment(this.defaultValue[0]).format('DD/MM/YYYY HH:mm'), Vue.moment(this.defaultValue[1]).format('DD/MM/YYYY HH:mm')])
        }
    }
</script>
